import React from "react";

import { useIntl } from "react-intl";

import CardType from "@app/enum/dashboard/CardType";
import ScopeTag from "@app/scene/dashboard/components/ScopeTag";
import useCard from "@app/scene/dashboard/utils/useCard";
import CardConfiguration from "@app/types/dashboard/CardConfiguration";
import Scope from "@app/types/dashboard/Scope";

import styles from "./Title.module.scss";

interface Props {
  configuration?: CardConfiguration<any, any, any>;
  scope: Scope;
  type: CardType;
}

const Title: React.FC<Props> = ({ configuration, scope, type }) => {
  const intl = useIntl();

  const card = useCard(type);
  return (
    <div className={styles.container}>
      <div className={styles.title}>{card.getModalTitle(intl, { configuration, scope })}</div>
      <ScopeTag scope={scope} />
    </div>
  );
};

export default Title;
